module.exports = __webpack_public_path__ + "static/media/OGG-tablet-privacy.0d8d3234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-tablet-privacy.jpg
// module id = 625
// module chunks = 0